export class RequestCancelledError extends Error {
  constructor() {
    super("Request was canceled");
  }
}
